import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card';

import { ArrowLeft, Camera, Check, X } from 'lucide-react';

const checklistItems = [
  { id: 1, label: 'Acabamento superficial adequado' },
  { id: 2, label: 'Dimensões dentro da tolerância' },
  { id: 3, label: 'Sem deformações ou warping' },
  { id: 4, label: 'Suportes removidos corretamente' },
];

export function Qualidade() {
  const navigate = useNavigate();
  const [checks, setChecks] = useState<Record<number, boolean>>({});
  useState<string[]>([]);

  const toggleCheck = (id: number) => {
    setChecks((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const todasMarcadas = checklistItems.every((item) => checks[item.id]);

  return (
    <div className="min-h-screen bg-fort3d-preto p-4">
      <div className="max-w-md mx-auto">
        {/* Header */}
        <div className="flex items-center gap-4 mb-6 pt-4">
          <button onClick={() => navigate('/modo-fabrica')} className="text-white">
            <ArrowLeft className="h-6 w-6" />
          </button>
          <h1 className="text-2xl font-bold text-white">Checklist de Qualidade</h1>
        </div>

        {/* Checklist */}
        <Card className="mb-6">
          <CardHeader>
            <CardTitle className="text-lg">Itens de Verificação</CardTitle>
          </CardHeader>
          <CardContent className="space-y-3">
            {checklistItems.map((item) => (
              <button
                key={item.id}
                onClick={() => toggleCheck(item.id)}
                className={`w-full flex items-center gap-3 p-4 rounded-xl border-2 text-left transition-all ${
                  checks[item.id]
                    ? 'border-fort3d-verde bg-fort3d-verde/10'
                    : 'border-fort3d-cinza-medio bg-fort3d-cinza-escuro'
                }`}
              >
                <div
                  className={`w-6 h-6 rounded-full flex items-center justify-center ${
                    checks[item.id] ? 'bg-fort3d-verde' : 'bg-fort3d-cinza-medio'
                  }`}
                >
                  {checks[item.id] && <Check className="h-4 w-4 text-white" />}
                </div>
                <span className={`flex-1 ${checks[item.id] ? 'text-white' : 'text-fort3d-cinza-claro'}`}>
                  {item.label}
                </span>
              </button>
            ))}
          </CardContent>
        </Card>

        {/* Fotos */}
        <Card className="mb-6">
          <CardHeader>
            <CardTitle className="text-lg">Registro Fotográfico</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-3 gap-3">
              <button className="aspect-square rounded-xl border-2 border-dashed border-fort3d-cinza-medio bg-fort3d-cinza-escuro flex flex-col items-center justify-center gap-2 text-fort3d-cinza-claro hover:border-fort3d-ciano hover:text-fort3d-ciano transition-colors">
                <Camera className="h-6 w-6" />
                <span className="text-xs">Antes</span>
              </button>
              <button className="aspect-square rounded-xl border-2 border-dashed border-fort3d-cinza-medio bg-fort3d-cinza-escuro flex flex-col items-center justify-center gap-2 text-fort3d-cinza-claro hover:border-fort3d-ciano hover:text-fort3d-ciano transition-colors">
                <Camera className="h-6 w-6" />
                <span className="text-xs">Durante</span>
              </button>
              <button className="aspect-square rounded-xl border-2 border-dashed border-fort3d-cinza-medio bg-fort3d-cinza-escuro flex flex-col items-center justify-center gap-2 text-fort3d-cinza-claro hover:border-fort3d-ciano hover:text-fort3d-ciano transition-colors">
                <Camera className="h-6 w-6" />
                <span className="text-xs">Depois</span>
              </button>
            </div>
          </CardContent>
        </Card>

        {/* Ações */}
        <div className="space-y-3">
          <Button
            variant="nuvem"
            size="xl"
            className="w-full"
            disabled={!todasMarcadas}
            leftIcon={<Check className="h-5 w-5" />}
            onClick={() => {}}
          >
            APROVAR PEÇA
          </Button>
          <Button
            variant="outline"
            size="lg"
            className="w-full border-fort3d-vermelho text-fort3d-vermelho hover:bg-fort3d-vermelho/10"
            leftIcon={<X className="h-5 w-5" />}
          >
            REGISTRAR REFUGO
          </Button>
        </div>
      </div>
    </div>
  );
}
